module.exports = __webpack_public_path__ + "img/approve-list3.4eab83a2.png";